import React, { createContext, useContext, useRef } from "react";

const AudioContext = createContext();

export const useAudio = () => {
  return useContext(AudioContext);
};

const AudioProvider = ({ children }) => {
  // 背景音乐
  const audioMainRef = useRef(null);

  // 初始化音频地址
  const [bgm, setBgm] = React.useState("https://rzza.51jkcloud.com/images/bgm.mp3");

  // 语音播报
  const audioRef = useRef("https://rzza.51jkcloud.com/images/narration-1-1.mp3");

  // 初始化音频地址
  const [bb, setBb] = React.useState(null);

  // 音频列表
  const list = [
    "https://rzza.51jkcloud.com/images/narration-1-1.mp3", // 0 第一关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-1-2.mp3", // 1 第一关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-2-1.mp3", // 2 第二关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-2-2.mp3", // 3 第二关 介绍二 语音播报
    "https://rzza.51jkcloud.com/images/narration-2-3.mp3", // 4 第二关 介绍三 语音播报

    "https://rzza.51jkcloud.com/images/narration-3-1.mp3", // 5 第三关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-3-2.mp3", // 6 第三关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-4-1.mp3", // 7 第四关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-4-2.mp3", // 8 第四关 介绍二 语音播报
    "https://rzza.51jkcloud.com/images/narration-4-3.mp3", // 9 第四关 介绍三 语音播报
    "https://rzza.51jkcloud.com/images/narration-4-4.mp3", // 10 第四关 介绍四 语音播报

    "https://rzza.51jkcloud.com/images/narration-5-1.mp3", // 11 第五关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-5-2.mp3", // 12 第五关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-6-1.mp3", // 13 第六关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-6-2.mp3", // 14 第六关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-7-1.mp3", // 15 第七关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-7-2.mp3", // 16 第七关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-8-1.mp3", // 17 第八关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-8-2.mp3", // 18 第八关 介绍二 语音播报
    "https://rzza.51jkcloud.com/images/narration-8-3.mp3", // 19 第八关 介绍三 语音播报

    "https://rzza.51jkcloud.com/images/narration-9-1.mp3", // 20 第九关 介绍一 语音播报

    "https://rzza.51jkcloud.com/images/narration-10-1.mp3", // 21 第十关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-10-2.mp3", // 22 第十关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-11-1.mp3", // 23 第十一关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-11-2.mp3", // 24 第十一关 介绍二 语音播报

    "https://rzza.51jkcloud.com/images/narration-12-1.mp3", // 25 第十二关 介绍一 语音播报
    "https://rzza.51jkcloud.com/images/narration-12-2.mp3", // 26 第十二关 介绍二 语音播报
  ];

  /*
    播放
    active: play | pause
    type: 0 > bgm 1 > 播报
    index: 播报下标
  */
  const playAudio = (active, type, index) => {
    console.log(active, type, index);
    if (active === "play") {
      // 播放
      if (type === 0) {
        // 背景音乐
        audioMainRef.current.loop = true;
        audioMainRef.current.play();
      } else {
        // 播报
        audioRef.current.src = list[index];
        audioRef.current.loop = true;
        audioRef.current.play();
      }
    } else {
      // 暂停
      if (type === 0) {
        audioMainRef.current.pause();
      } else {
        audioRef.current.pause();
      }
    }
  };

  return (
    <AudioContext.Provider value={{ playAudio }}>
      {children}
      <audio ref={audioMainRef}>
        <source src={bgm} volume="0.5" type="audio/mpeg" />
      </audio>

      <audio ref={audioRef}>
        <source src={bb} volume="0.8" type="audio/mpeg" />
      </audio>
    </AudioContext.Provider>
  );
};

export default AudioProvider;
